<template>
  <div id="app">
      <Navbar/>
      <div class="fadingAlertContainer">
        <FadingAlert class="fadingAlert"/>  
      </div>
      <router-view />
    </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import FadingAlert from "@/components/Fading-Alert.vue";
import { mixins } from "@/mixins";

export default {
  name: 'App',
  data () {
    return {
      logoutRoutes: ["Home", "LoginStudio", "LoginLab"]
    }
  },
  mixins: [mixins],
  components: {
    Navbar,
    FadingAlert,
  },
  mounted(){
    document.title = "Laboratori";
    if(this.logoutRoutes.includes(this.$route.name)){
      this.logout();
    }
  },
  watch: {
    '$route': function() {
      let routeName = this.$route.name;
      if (this.logoutRoutes.includes(routeName) && this.$store.getters['isLoggedIn']){
        this.logout();
      }
      if (!this.logoutRoutes.includes(routeName)){
        this.$axios
        .post(this.$apibase + '/auth/refresh_token/', 
          {
            token: localStorage.getItem('access_token')
          },
          {
            headers:{
              "Content-Type": "application/json"
            }          
          }
          
        )
        .then((response) => {
          localStorage.setItem('access_token', response.data.token)
        })
        .catch((e) => {
          if (e.response.status == 403)
            this.logout();
          else
            alert(e.response);
        })
      }
    }
  }
}
</script>



<style>
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #707070;
  padding-bottom: 100px;
}

#app h1 {
  font-size: 23px;
  font-weight: bold;
  color: #707070;
}

#app a {
  text-decoration: none;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.fadingAlertContainer{
  width:100%;
  text-align: center;
  margin-top: 40px;
}

.fadingAlert{
  width: 70%;
  max-width: 800px;
  /* align-items: center; */
  display: inline-block;
  margin-bottom: 0;
}

.loader-container {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  display: block;
}

.loader {
  border: 12px solid #f3f3f3; /* Light grey */
  border-top: 12px solid #6ABF67; /* Blue */
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: spin 2s linear infinite;
  display: inline-block;

}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.searchbar-container {
       padding-top: 20px;
       height: 40px;
    }
</style>
